var e = /* @__PURE__ */ ((r) => (r.Error = "error", r.Neutral = "neutral", r.Success = "success", r))(e || {});
const c = 5e3;
export {
  c as TOAST_VISIBILITY_DURATION,
  e as VariantsEnum
};
